/**
 * @generated SignedSource<<b91af92e42f6205e8ea8e79a70d47325>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MusicUpdatePieceFileChangeTempoInput = {
  piece_id: string;
  tempo_bpm: number;
};
export type UpdatePieceFileChangeTempoMutation$variables = {
  input: MusicUpdatePieceFileChangeTempoInput;
};
export type UpdatePieceFileChangeTempoMutation$data = {
  readonly music_update_piece_file_change_tempo: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PiecePlayBody_piece" | "PieceSettingsBody_piece">;
    };
  };
};
export type UpdatePieceFileChangeTempoMutation = {
  variables: UpdatePieceFileChangeTempoMutation$variables;
  response: UpdatePieceFileChangeTempoMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePieceFileChangeTempoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_update_piece_file_change_tempo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PiecePlayBody_piece"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PieceSettingsBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePieceFileChangeTempoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_update_piece_file_change_tempo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "output_storage_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicPieceFile",
                "kind": "LinkedField",
                "name": "file",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MusicPieceFileNote",
                    "kind": "LinkedField",
                    "name": "notes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bulb_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "left_handed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_start",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "midi_number",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "page_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pitch_name",
                        "storageKey": null
                      },
                      {
                        "alias": "sheet_id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "page_id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Box",
                        "kind": "LinkedField",
                        "name": "boxes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "x",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "y",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "audio_file_download_url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "midi_file_download_url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tempo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnail_download_url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "end_to_end_test_file_download_url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7ca4d75a6359fe43110dd894d1e92be",
    "id": null,
    "metadata": {},
    "name": "UpdatePieceFileChangeTempoMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePieceFileChangeTempoMutation(\n  $input: MusicUpdatePieceFileChangeTempoInput!\n) {\n  music_update_piece_file_change_tempo(input: $input) {\n    piece {\n      id\n      ...PiecePlayBody_piece\n      ...PieceSettingsBody_piece\n    }\n  }\n}\n\nfragment Export_Piece on MusicPiece {\n  id\n  file {\n    version\n    midi_file_download_url\n    audio_file_download_url\n  }\n}\n\nfragment ListenPlayer_Piece on MusicPiece {\n  id\n  ...PieceRenderer_piece\n  ...PieceRendererStepThru_piece\n  file {\n    audio_file_download_url\n    duration\n    notes {\n      bulb_id\n      note_start\n      note_duration\n      midi_number\n    }\n  }\n}\n\nfragment OnSheetNoteByNotePlayer_Piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      midi_number\n      left_handed\n      note_start\n    }\n  }\n  ...SheetRenderer_piece\n}\n\nfragment PiecePlayBody_piece on MusicPiece {\n  id\n  ...ListenPlayer_Piece\n  ...SimplifiedNoteByNotePlayer_Piece\n  ...OnSheetNoteByNotePlayer_Piece\n  ...Export_Piece\n}\n\nfragment PieceRendererNoteChangeDuration_note on MusicPieceFileNote {\n  bulb_id\n  note_duration\n}\n\nfragment PieceRendererNoteTooltip_note on MusicPieceFileNote {\n  page_id\n  note_id\n  bulb_id\n  midi_number\n  note_start\n  note_duration\n  ...PieceRendererViewAttributes_note\n  ...PieceRendererNoteChangeDuration_note\n}\n\nfragment PieceRendererNote_note on MusicPieceFileNote {\n  bulb_id\n  note_start\n  midi_number\n  note_duration\n  ...PieceRendererNoteTooltip_note\n}\n\nfragment PieceRendererStepThruNote_note on MusicPieceFileNote {\n  bulb_id\n  note_duration\n  note_start\n  midi_number\n}\n\nfragment PieceRendererStepThru_piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      note_duration\n      note_start\n      midi_number\n      ...PieceRendererStepThruNote_note\n    }\n  }\n}\n\nfragment PieceRendererViewAttributes_note on MusicPieceFileNote {\n  note_id\n  bulb_id\n  midi_number\n  pitch_name\n  left_handed\n  note_start\n}\n\nfragment PieceRenderer_piece on MusicPiece {\n  id\n  output_storage_name\n  file {\n    notes {\n      bulb_id\n      left_handed\n      note_start\n      ...PieceRendererNote_note\n    }\n  }\n}\n\nfragment PieceSettingsBodyEmployeeOnlySection_piece on MusicPiece {\n  id\n  end_to_end_test_file_download_url\n}\n\nfragment PieceSettingsBody_piece on MusicPiece {\n  id\n  name\n  ...PieceSettingsNameItem_Piece\n  ...PieceSettingsBodyEmployeeOnlySection_piece\n  ...PieceSettingsTempoItem_piece\n}\n\nfragment PieceSettingsNameItem_Piece on MusicPiece {\n  id\n  name\n}\n\nfragment PieceSettingsTempoItem_piece on MusicPiece {\n  id\n  file {\n    tempo\n  }\n}\n\nfragment SheetRendererNoteBox_box on Box {\n  x\n  y\n  width\n  height\n}\n\nfragment SheetRendererNote_note on MusicPieceFileNote {\n  bulb_id\n  sheet_id: page_id\n  boxes {\n    ...SheetRendererNoteBox_box\n  }\n}\n\nfragment SheetRenderer_piece on MusicPiece {\n  id\n  file {\n    notes {\n      bulb_id\n      ...SheetRendererNote_note\n    }\n  }\n  sheets {\n    id\n    width\n    height\n    thumbnail_download_url\n  }\n}\n\nfragment SimplifiedNoteByNotePlayer_Piece on MusicPiece {\n  id\n  ...PieceRenderer_piece\n  ...PieceRendererStepThru_piece\n  file {\n    notes {\n      left_handed\n      note_start\n      bulb_id\n      midi_number\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5b60d9dd9af3c707653cbb6fa9d4b61";

export default node;
